import { Component, Injector, OnInit } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-upcoming',
  templateUrl: './upcoming.component.html',
  styleUrls: ['./upcoming.component.css']
})
export class UpcomingComponent  extends BaseClass<any> implements OnInit {

  public _pusher!: PusherService;

  constructor(public service: WebserviceService, private injector: Injector) {
    super(document);

    this.navMarquee = this.getLocalItem('marquee', false) != null ? this.getLocalItem('marquee', false) : 'Welcome To Our Exchange.';    

    if (this.isLogin()) {
      this._pusher = injector.get<PusherService>(PusherService);
      this._pusher.globalMsgUpdate().subscribe(res => {        
        if (res)
          this.navMarquee = res.message != null ? res.message : '';
      });
    }
  }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }
}